(ns dashboard.events.events
  (:require
   [re-frame.core :as re-frame]
   [graphql-query.core :refer [graphql-query]]
   [dashboard.utils :refer [graphql-request-format index-of ->json]]
   [dashboard.interceptors :refer [standard-interceptors]]
   [dashboard.config :as config]
   ["date-fns" :refer [isBefore]]))

(def event-fields
  [:id :name :nameJp :organizationId :start :end :floorplanUrl :floorplanConfig])

;; Create Event

(defn create-event-query
  [{:keys [event]}]
  {:operation {:operation/type :mutation
               :operation/name :addEvent}
   :queries [[:addEvent
              event
              event-fields]]})

(re-frame/reg-event-fx
 ::create-event
 standard-interceptors
 (fn [{:keys [db]} [{:keys [event]}]]
   {:graphql-request {:query (graphql-query (create-event-query
                                             {:event event}))
                      :on-success [::create-event-success]}}))

(re-frame/reg-event-fx
 ::create-event-success
 standard-interceptors
 (fn [{:keys [db]} [res]]
   (if (some? (:errors res))
     {:show-notification!
      {:title "Error Creating Event"
       :intent :intent/danger
       :duration 10000
       :message (clojure.string/join "\n" (map :message (:errors res)))}}
     {:show-notification!
      {:title "Event Created"
       :intent :intent/success
       :duration 10000
       :message (str "You successfuly created " (:name (get-in res [:data :addEvent])))}
      :dispatch [::add-event (get-in res [:data :addEvent])]})))

;; Update Event

(defn update-event-query
  [{:keys [event]}]
  {:operation {:operation/type :mutation
               :operation/name :updateEvent}
   :queries [[:updateEvent
              (-> event
                  (dissoc :organizationId :created)
                  (assoc :floorplanConfig (->json (:floorplanConfig event))))
              event-fields]]})

(re-frame/reg-event-fx
 ::update-event
 standard-interceptors
 (fn [{:keys [db]} [{:keys [event]}]]
   {:graphql-request {:query (graphql-query (update-event-query {:event event}))
                      :on-success [::update-event-success]}}))

(re-frame/reg-event-fx
 ::update-event-success
 standard-interceptors
 (fn [{:keys [db]} [res]]
   (if (some? (:errors res))
     {:show-notification!
      {:title "Error Updating Event"
       :intent :intent/danger
       :duration 10000
       :message (clojure.string/join "\n" (map :message (:errors res)))}}
     {:show-notification!
      {:title "Event Updated"
       :intent :intent/success
       :duration 10000
       :message (str "You successfuly updated the event "
                     (:name (get-in res [:data :updateEvent])))}
      :dispatch [::edit-event (get-in res [:data :updateEvent])]})))

;; Create Event

(defn delete-event-query
  [{:keys [event]}]
  {:operation {:operation/type :mutation
               :operation/name :deleteEvent}
   :queries [[:deleteEvent
              {:id (:id event)}
              event-fields]]})

(re-frame/reg-event-fx
 ::delete-event
 standard-interceptors
 (fn [{:keys [db]} [{:keys [event]}]]
   {:graphql-request {:query (graphql-query (delete-event-query {:event event}))
                      :on-success [::delete-event-success]}}))

(re-frame/reg-event-fx
 ::delete-event-success
 standard-interceptors
 (fn [{:keys [db]} [res]]
   (if (some? (:errors res))
     {:show-notification!
      {:title "Error Deleting Event"
       :intent :intent/danger
       :duration 10000
       :message (clojure.string/join "\n" (map :message (:errors res)))}}
     {:show-notification!
      {:title "Event Deleted"
       :intent :intent/success
       :duration 10000
       :message (str "You successfuly deleted " (:name (get-in res [:data :deleteEvent])))}
      :dispatch [::remove-event (get-in res [:data :deleteEvent])]})))

;; Add a event to the list of events in the application db
(re-frame/reg-event-db
 ::add-event
 standard-interceptors
 (fn [db [event]]
   (update-in db [:event-organizer/events] conj event)))

;; Edit a event to the list of events in the application db
(re-frame/reg-event-db
 ::edit-event
 standard-interceptors
 (fn [db [event]]
   (let [event-idx (index-of (map :id (:event-organizer/events db)) (:id event))]
     (update-in db [:event-organizer/events event-idx] merge event))))

;; Remove a event from the list of events in the application db
(re-frame/reg-event-db
 ::remove-event
 standard-interceptors
 (fn [db [event]]
   (let [old-events (:event-organizer/events db)
         new-events (into [] (filter #(not= (:id %) (:id event)) old-events))]
     (assoc db :event-organizer/events new-events))))

;; List Events

(defn list-events-by-organization-query
  [{:keys [organization-id]}]
  {:operation {:operation/type :query
               :operation/name :allEventsByOrganization}
   :queries [[:allEventsByOrganization
              {:organizationId organization-id}
              {:events event-fields}]]})

(re-frame/reg-event-fx
 ::list-events-by-organization
 standard-interceptors
 (fn [{:keys [db]} [{:keys [organization-id]}]]
   (let [organization-id (or organization-id
                             (get-in db [:settings :organization :id]))]
     {:graphql-request {:query (graphql-query (list-events-by-organization-query
                                               {:organization-id organization-id}))
                        :on-success [::list-events-by-organization-success]}})))

(re-frame/reg-event-fx
 ::list-events-by-organization-success
 standard-interceptors
 (fn [{:keys [db]} [res]]
   {:db (assoc db :event-organizer/events (get-in res [:data :allEventsByOrganization :events]))}))

;; Set a event-uuid to the selected space-uuid db key
(re-frame/reg-event-db
 ::select-event
 standard-interceptors
 (fn [db [event]]
   (assoc-in db [:event-organizer/selected :event-id] (:id event))))

;; Set a space-uuid to the selected space-uuid db key based on active spaces and
;; user assigned space
(re-frame/reg-event-db
 ::select-default-event
 standard-interceptors
 (fn [db [space]]
   (let [passed-event-ids (->> (:event-organizer/events db)
                               (filter #(isBefore (js/Date. (:end %)) (js/Date.)))
                               (map :id))
         active-event-ids (->> (:event-organizer/events db)
                               (remove #(isBefore (js/Date. (:end %)) (js/Date.)))
                               (sort-by :start)
                               (map :id))
         default-event-id (or (first active-event-ids) (last passed-event-ids))]
     (assoc-in db [:event-organizer/selected :event-id] default-event-id))))
